<!-- <header>
    <div class="left portal-layout">
        <a routerLink="" class="sage">
            <a routerLink="customer-portal" class="logo"><img src="images/sage.svg" alt="Sage" height="31.75px" width="57px"></a>
            Customer Portal</a>

        <div class="logo">
        </div>

    </div>
    <div class="center">
        <a class="normalheading" [href]="getLinkForAllGuided()" target="_blank">{{'navbar.guides' | translate}}</a>
        <a class="normalheading" href="https://communityhub.sage.com/global-resources" target="_blank">{{'navbar.resources' | translate}}</a>
        <a class="normalheading" [href]="getSupportContactUsLink()" target="_blank">{{'navbar.contactUs' | translate}}</a>

    </div>
    <div class="right">
        @if (authService.isLoggedIn()) {
        <button type="button" class="btn btn-sm btn-custom-class" (click)="signOut()">Logout</button>
        }
    </div>
</header> -->
<nav class="navbar navbar-expand-lg bg-body-tertiary dark">
  <div class="container-fluid header-pad">
    <div class="left">
      <a routerLink="" class="sage align-items-center">
        <a routerLink="customer-portal" class="logo navbar-brand"><img src="images/sage.svg" alt="Sage" height="31.75px"
            width="57px"></a>
        {{getPortalText() | translate}}</a>
    </div>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0,0,256,256"
          style="fill:#FFFFFF;">
          <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
            stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
            font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <g transform="scale(5.12,5.12)">
              <path d="M0,9v2h50v-2zM0,24v2h50v-2zM0,39v2h50v-2z"></path>
            </g>
          </g>
        </svg>
      </span>
    </button>
    <div class="collapse navbar-collapse justify-content-evenly" id="navbarNavAltMarkup">
      <div class="navbar-nav">
        <a class="normalheading nav-link active" [href]="getLinkForAllGuided()" target="_blank">{{'navbar.guides' |
          translate}}</a>
        <a class="normalheading nav-link" href="https://communityhub.sage.com/global-resources" target="_blank">{{'navbar.resources' | translate}}</a>
        <a class="normalheading nav-link" [href]="getSupportContactUsLink()" target="_blank">{{'navbar.contactUs' | translate}}</a>

      </div>
    </div>
    <div class="d-flex align-items-end">
      <div>
        <div *ngIf="authService.isLoggedIn$ | async">
          <button type="button" class="btn btn-sm btn-custom-class" (click)="signOut()">
            {{ 'navbar.signOut' | translate }}
          </button>
        </div>   
      </div>
    </div>
  </div>
</nav>
